(() => {
  const prefersReduced = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

  const preloadAndDecode = (url) => {
    return new Promise((resolve) => {
      if (!url) return resolve(null);
      const i = new Image();
      i.decoding = 'async';
      i.src = url;

      const done = () => resolve(i);
      // decode() makes swaps feel MUCH smoother when supported
      if (i.decode) i.decode().then(done).catch(done);
      else i.onload = done, i.onerror = done;
    });
  };

  const findMainImage = (card) => {
    // Horizon can render multiple imgs; try the gallery area first
    const root =
      card.querySelector('product-card-gallery') ||
      card.querySelector('[data-testid="product-card-media"]') ||
      card.querySelector('.product-card__media') ||
      card;

    // Prefer an img that looks like the main one
    return (
      root.querySelector('img:not([loading="lazy"])') ||
      root.querySelector('img')
    );
  };

  const setPictureSources = (imgEl, url) => {
    if (!imgEl) return;

    // If inside <picture>, update sources too
    const picture = imgEl.closest('picture');
    if (picture) {
      picture.querySelectorAll('source').forEach((s) => {
        s.setAttribute('srcset', url);
      });
    }

    imgEl.setAttribute('src', url);
    // Avoid old responsive srcset fighting the new image
    imgEl.removeAttribute('srcset');
    imgEl.removeAttribute('data-srcset');
    imgEl.setAttribute('data-src', url);
  };

  const setActive = (card, swatch) => {
    card.querySelectorAll('.hzn-card-swatch').forEach((s) => s.classList.remove('is-active'));
    swatch.classList.add('is-active');
  };

  const updateCardLink = (card, variantUrl, featuredMediaUrl) => {
    // Update the overlay link so clicking the card after chooses the selected variant
    const link = card.querySelector('.product-card__link');
    if (link && variantUrl) link.setAttribute('href', variantUrl);

    // If wrapped in product-card-link component, update its data for transitions
    const pcl = card.closest('product-card-link');
    if (pcl && featuredMediaUrl) pcl.setAttribute('data-featured-media-url', featuredMediaUrl);
  };

  // Preload all swatch images when browser is idle (huge lag reduction)
  const preloadAll = () => {
    const urls = new Set();
    document.querySelectorAll('.hzn-card-swatch[data-variant-image]').forEach((s) => {
      const u = s.getAttribute('data-variant-image');
      if (u) urls.add(u);
    });

    // soft limit so we don't crush the network
    let count = 0;
    for (const u of urls) {
      if (count >= 40) break;
      const i = new Image();
      i.decoding = 'async';
      i.src = u;
      count++;
    }
  };

  if ('requestIdleCallback' in window) requestIdleCallback(preloadAll, { timeout: 1200 });
  else setTimeout(preloadAll, 600);

  document.addEventListener('click', async (e) => {
    const swatch = e.target.closest('.hzn-card-swatch');
    if (!swatch) return;

    const variantUrl = swatch.getAttribute('data-variant-url') || swatch.getAttribute('href');
    const imgUrl = swatch.getAttribute('data-variant-image');

    // If no image available, just navigate normally
    if (!imgUrl) return;

    const card =
      swatch.closest('product-card') ||
      swatch.closest('.product-card') ||
      swatch.closest('.product-grid__card');

    if (!card) return;

    // prevent navigation (premium in-place swap)
    e.preventDefault();

    const imgEl = findMainImage(card);
    if (!imgEl) return;

    // prevent spam clicks causing jank
    if (card.__hznSwapping) return;
    card.__hznSwapping = true;

    try {
      setActive(card, swatch);

      // Preload + decode first → smooth swap
      await preloadAndDecode(imgUrl);

      updateCardLink(card, variantUrl, imgUrl);

      if (!prefersReduced) {
        imgEl.style.transition = 'opacity 160ms ease';
        imgEl.style.opacity = '0';
        await new Promise((r) => setTimeout(r, 120));
      }

      setPictureSources(imgEl, imgUrl);

      if (!prefersReduced) {
        requestAnimationFrame(() => {
          imgEl.style.opacity = '1';
        });
      } else {
        imgEl.style.opacity = '1';
      }
    } finally {
      // small delay to avoid double swaps fighting
      setTimeout(() => {
        card.__hznSwapping = false;
      }, 180);
    }
  });
})();
